export enum FilterSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
  NONE = '',
}
